module.exports = __webpack_public_path__ + "img/ccdsrichengqr.54c1b6de.png";